<template>
  <v-row justify="center">
    <v-alert
      id="alert"
      :value="isErrorDisplayed"
      type="error"
      dismissible
      @input="setErrorDisplayed"
    >
      {{ getErrorMessage }}
    </v-alert>
  </v-row>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'AlertError',

    computed: {
      ...mapGetters(['isErrorDisplayed', 'getErrorMessage']),
    },

    methods: {
      ...mapActions(['setErrorDisplayed']),
    },
  }
</script>

<style scoped>
#alert {
  z-index: 1000;
  top: 8px;
  position: absolute;
  max-width: 90%;
}
</style>
